module.exports = __webpack_public_path__ + "media/images/video-screenshot-f7afb5d0505cccf372a8ef32f508d90d.jpg";